import React from 'react';

const WelcomeMessage = () => {
  return (
    <div className="welcome-message">
      <div className="welcome-content">
        <i className="fas fa-graduation-cap welcome-icon"></i>
        <h2>Welcome to Azure Certification Flashcards</h2>
        <p>Select a certification from above to start studying!</p>
        <div className="welcome-features">
          <div className="feature">
            <i className="fa fa-id-card"></i>
            <span>Interactive flashcards</span>
          </div>
          <div className="feature">
            <i className="fas fa-random"></i>
            <span>Shuffle & practice</span>
          </div>
          <div className="feature">
            <i className="fas fa-chart-line"></i>
            <span>Track progress</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;
